<template>
  <div v-if="tab">
    <h6 class="mt-2 pt-50 mb-1">
      {{ $t('therms.in-detail') }}
    </h6>
    <touch-button-group
      v-if="hasMultipleModules && (sheets && deliveries)"
      class="w-100 mb-2 d-flex"
    >
      <touch-button
        v-if="sheets"
        class="flex-fill"
        :class="{'active' : tab === expeditionSheetTab}"
        ingroup
        outline
        thinkiness
        size="sm"
        style="width: 33%"
        @action="tab = expeditionSheetTab"
      >
        <span class="wrap">{{ $t('therms.expedition_sheets') }}</span>
      </touch-button>
      <touch-button
        v-if="deliveries"
        class="flex-fill"
        :class="{'active' : tab === deliveryTab}"
        ingroup
        outline
        thinkiness
        size="sm"
        style="width: 33%"
        @action="tab = deliveryTab"
      >
        <span class="wrap">{{ $t('therms.delivery_sheets') }}</span>
      </touch-button>
    </touch-button-group>
    <template
      v-if="tab === expeditionSheetTab && sheets"
    >
      <template
        v-if="sortedSheets.length===0"
      >
        <b-list-group>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            :disabled="true"
          >
            {{ $t('therms.no-expedition-sheet') }}
          </b-list-group-item>
        </b-list-group>
      </template>
      <template v-else>
        <app-collapse
          type="border"
          class="animate__animated animate__fadeInUp"
        >
          <app-collapse-expedition-sheet :list="sortedSheets" />
        </app-collapse>
      </template>
    </template>

    <template
      v-if="tab === deliveryTab && deliveries"
    >
      <template
        v-if="sortedDeliveries.length===0"
      >
        <b-list-group>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            :disabled="true"
          >
            {{ $t('therms.no-delivery') }}
          </b-list-group-item>
        </b-list-group>
      </template>
      <template v-else>
        <app-collapse
          type="border"
          class="animate__animated animate__fadeInUp"
        >
          <app-collapse-delivery :list="sortedDeliveries" />
        </app-collapse>
      </template>
    </template>
  </div>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseExpeditionSheet from '@/views/components/AppCollapseExpeditionSheet.vue'
import AppCollapseDelivery from '@/views/components/AppCollapseDelivery.vue'
import TouchButton from '@core/components/touch-button/TouchButton.vue'
import TouchButtonGroup from '@core/components/touch-button/TouchButtonGroup.vue'
import { mapGetters } from 'vuex'
import { BListGroup, BListGroupItem } from 'bootstrap-vue'

export default {
  components: {
    BListGroup,
    BListGroupItem,
    AppCollapseExpeditionSheet,
    AppCollapse,
    AppCollapseDelivery,
    TouchButton,
    TouchButtonGroup,
  },
  props: {
    sheets: {
      type: Array,
      required: false,
      default: () => [],
    },
    deliveries: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      tab: this.expeditionSheetTab,
    }
  },
  computed: {
    ...mapGetters({
      getModules: 'modules/getModules',
    }),
    /**
     * @returns {string}
     */
    expeditionSheetTab() {
      return 'expedition_sheets'
    },
    /**
     * @returns {string}
     */
    deliveryTab() {
      return 'delivery'
    },
    sortedSheets() {
      return [...this.sheets]
        .sort((a, b) => new Date(a.datetime) - new Date(b.datetime))
    },
    sortedDeliveries() {
      return [...this.deliveries]
        .sort((a, b) => new Date(a.datetime) - new Date(b.datetime))
    },
    status() {
      return [
        {
          1: 'Expedié',
          0: 'Annulé',
        },
        {
          1: 'light-success',
          0: 'light-danger',
        },
      ]
    },
    hasMultipleModules() {
      return this.getModules.includes('shipping') && this.getModules.includes('shipping-delivery')
    },
  },
  watch: {},
  mounted() {
    if (this.getModules.includes('shipping')) {
      this.tab = this.expeditionSheetTab
    } else if (this.getModules.includes('shipping-delivery')) {
      this.tab = this.deliveryTab
    }
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import '@core/scss/base/bootstrap-extended/_include';
@import '@core/scss/base/components/_include';

table tr td:nth-child(2) {
  padding-left: 20px;
}

.inputDate {
  position: relative;
  z-index: -100;
  top: 10px;
  opacity: 0;
}

</style>
